import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import { IActionsHeaderKpi } from '@base/@types/providers/Kpi/RuptureProvider'

export const actionsRuptureHeaderKpi = ({
  data,
  headers,
  toggleColumn,
  parseRuptureKpiData
}: IActionsHeaderKpi) => {
  return [
    {
      type: 'export',
      exports: [
        {
          type: 'excel',
          entity: 'ruptureKpi',
          data,
          headers,
          parser: parseRuptureKpiData
        }
      ]
    },
    {
      type: 'columns',
      data: headers,
      onToggleColumn: toggleColumn
    }
  ] as ILayoutToolsAction[]
}
